import { Space, Spin, Typography, message } from "antd";
import axios from "axios";
import Pusher from "pusher-js";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import { NotificationInfo, UserInfo } from "./context";
import AllRoute from "./routes/AllRoute,";
import LoginRoute from "./routes/LoginRoute";
// import "leaflet/dist/leaflet.css";
// import * as PusherPushNotifications from "@pusher/push-notifications-web";

// const beamsClient = new PusherPushNotifications.Client({
//   instanceId: import.meta.env.VITE_API_PUSHER_BEAM,
// });

axios.defaults.baseURL = import.meta.env.VITE_API;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "digitkn"
)}`;

const pusher = new Pusher(import.meta.env.VITE_API_PUSHER_KEY, {
  cluster: "ap1",
});

function MyApp() {
  const digitkn = localStorage.getItem("digitkn");
  const [isLoading, setIsLoading] = React.useState(true);
  const [userData, setUserData] = React.useState({
    data: [],
    ready: false,
  });
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const channel = pusher.subscribe("channels");
  const [isMobile, setIsMobile] = React.useState(
    window.innerWidth <= 650 ? true : false
  );

  const messagingNotif = (type, content) => {
    messageApi.open({
      type,
      content,
    });
  };

  const handleLogout = () => {
    messagingNotif("error", "Session Expire! Logged out automatically.");
    setTimeout(() => {
      localStorage.removeItem("digitkn");
      navigate("/");
      navigate(0);
    }, 1000);
  };

  const getTokenAndAccess = () => {
    axios
      .get("user/me")
      .then(function (response) {
        const data = response.data;
        if (data.message === "success") {
          setUserData({
            data: data.result,
            ready: true,
          });
          setTimeout(() => {
            setIsLoading(false);
          }, 0);
        }
      })
      .catch(function (error) {
        if (error.message === "Request failed with status code 401") {
          handleLogout();
          setTimeout(() => {
            setIsLoading(false);
          }, 0);
        }
      });
  };

  const handleLogoutTkn = () => {
    axios
      .post("user/logout")
      .then(function (response) {
        console.log("response.data", response.data);
        messagingNotif("success", "Logged out successfully.");
        localStorage.removeItem("digitkn");
        navigate("/");
        navigate(0);
      })
      .catch(function (error) {
        console.log("ERROR: ", error);
      });
  };

  // function DisableDevTools() {
  //   document.addEventListener("contextmenu", (e) => {
  //     e.preventDefault();
  //   });
  //   document.onkeydown = function (e) {
  //     if (e.keyCode === 123) {
  //       return false;
  //     }
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === "I".charCodeAt(0)) {
  //       return false;
  //     }
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === "C".charCodeAt(0)) {
  //       return false;
  //     }
  //     if (e.ctrlKey && e.shiftKey && e.keyCode === "J".charCodeAt(0)) {
  //       return false;
  //     }
  //     if (e.ctrlKey && e.keyCode === "U".charCodeAt(0)) {
  //       return false;
  //     }
  //   };
  // }

  function detectWindowSize() {
    window.innerWidth <= 650 ? setIsMobile(true) : setIsMobile(false);
  }

  React.useEffect(() => {
    // DisableDevTools();

    if (digitkn !== null) {
      // setIsLoading(true);
      getTokenAndAccess();
    } else {
      setTimeout(() => {
        setIsLoading(false);
      }, 0);
    }

    // setTimeout(function () {
    //   document.querySelector("a").style.display = "none";
    // }, 10);

    window.onresize = detectWindowSize;

    return () => {
      pusher.unsubscribe("channels");
    };

    // eslint-disable-next-line
  }, [digitkn]);
  return (
    <>
      <UserInfo.Provider
        value={{
          // beamsClient,
          channel,
          userData,
          setUserData,
          handleRerunUser: () => getTokenAndAccess(),
          handleLogoutTkn: () => handleLogoutTkn(),
          isMobile,
        }}
      >
        <NotificationInfo.Provider
          value={{
            rerunNotif: (type, content) => messagingNotif(type, content),
          }}
        >
          {isLoading && (
            <Space
              direction="vertical"
              size={0}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100vh",
              }}
            >
              <Spin size="large">
                <Typography.Title
                  level={4}
                  style={{ paddingTop: 80, margin: 0 }}
                >
                  Loading...
                </Typography.Title>
              </Spin>
            </Space>
          )}

          {!isLoading && (
            <>
              {userData.ready && <AllRoute module={userData.data.module} />}
              {!userData.ready && <LoginRoute />}
            </>
          )}

          {/* {isLoading ? (
            <Space
              direction="vertical"
              size={0}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100vh",
              }}
            >
              <Spin size="large">
                <Typography.Title
                  level={4}
                  style={{ paddingTop: 80, margin: 0 }}
                >
                  Loading...
                </Typography.Title>
              </Spin>
            </Space>
          ) : (
            <>{userData.ready ? <AllRoute /> : <LoginRoute />}</>
          )} */}
        </NotificationInfo.Provider>
      </UserInfo.Provider>

      {contextHolder}
    </>
  );
}

export default function ToggleColorMode() {
  return <MyApp />;
}
